import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { Icon } from 'semantic-ui-react';
import './PhishingTemplateHeader.css';

function PhishingTemplateHeader(props) {
  const { formatMessage } = props.intl;
  const { runCodeHandler, submitPhishingTemplate } = props;

  const phishingType = [
    defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_28', defaultMessage: '정보 제공' })),
    defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_29', defaultMessage: '링크 설정' }))
  ]

  const reserveList = [
    {
      title: defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_12', defaultMessage: '이름' })),
      reservation: '${TARGET_NAME}$',
      type: phishingType[0]
    },
    {
      title: defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_13', defaultMessage: '이메일' })),
      reservation: '${TARGET_EMAIL}$',
      type: phishingType[0]
    },
    {
      title: defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_34', defaultMessage: '아이디' })),
      reservation: '${TARGET_ID}$',
      type: phishingType[0]
    },
    {
      title: defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_14', defaultMessage: '연락처' })),
      reservation: '${TARGET_PHONE}$',
      type: phishingType[0]
    },
    {
      title: defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_15', defaultMessage: '소속' })),
      reservation: '${TARGET_DIVISION}$',
      type: phishingType[0]
    },
    {
      title: defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_16', defaultMessage: '직급' })),
      reservation: '${TARGET_POSITION}$',
      type: phishingType[0]
    },
    {
      title: defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_17', defaultMessage: '피싱 단계 진행' })),
      reservation: '${STAGE_NEXT}$',
      type: phishingType[1]
    },
    {
      title: defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_18', defaultMessage: '피싱 결과 화면 실행' })),
      reservation: '${STAGE_FINISH}$',
      type: phishingType[1]
    }
  ];

  const reserveEl = reserveList.map(item => {
    return (
      <dd key={item.title} className="reserve-data">
        <div>{item.title}</div>
        <div>{item.reservation}</div>
        <div>{item.type}</div>
      </dd>
    );
  });

  return (
    <div className="modal-phishing-header">
      <div>
        <img src="/img/logo/mf_logo_white_small_v.png" alt="logo" />
      </div>
      <div className="util-btns">
        <div className="excute-btn" title="Ctrl + Enter" onClick={runCodeHandler}>
          <Icon name="play" />
          <span>
            {defineMessages(
              formatMessage({
                id: 'PhishingTemplateEditModal_7',
                defaultMessage: '실 행'
              })
            )}</span>
        </div>
        <div className="save-btn" onClick={submitPhishingTemplate}>
          <Icon name="save" />
          <span>
            {defineMessages(
              formatMessage({
                id: 'PhishingTemplateEditModal_5',
                defaultMessage: '저 장'
              })
            )}
          </span>
        </div>
        <div className="reservation-modal-wrapper">
          <div className="reservation-btn">
            <div className="reservation-hover">
              {defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_8', defaultMessage: '예약어' }))}
            </div>
            <div className="reservation-info">
              {defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_9', defaultMessage: '템플릿 제작 시 필요한 정보를 확인하세요.' }))}
            </div>
          </div>
          <div className="reservation-modal">
            <dl>
              <dt className="reserve-header">
                <div>{defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_11', defaultMessage: '대상' }))}</div>
                <div>{defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_8', defaultMessage: '예약어' }))}</div>
                <div>{defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_27', defaultMessage: '유형' }))}</div>
              </dt>
              {reserveEl}
            </dl>
            <div className="reserve-example">
              <div className="bold">{'ex )'}</div>
              <div className="example-text">
                <span>
                  <span>{defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_28', defaultMessage: '정보 제공' })) + ' : '}</span>
                </span>
                {defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_30', defaultMessage: '${TARGET_NAME}$님께 드리는 마지막 이벤트!' }))}
              </div>
              <div className="example-text">
                <span>
                  <span>{defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_29', defaultMessage: '링크 설정' })) + ' : '}</span>
                </span>
                {'<a href=${STAGE_NEXT}$ target="_blank">'}
                {defineMessages(formatMessage({ id: 'PhishingTemplateEditModal_31', defaultMessage: '휴대폰 인증' }))}
                {'</a>'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(PhishingTemplateHeader);



// WEBPACK FOOTER //
// ./src/script/components/phishingTemplate/phishingTemplateModal/phishingTemplateHeader/PhishingTemplateHeader.js